const STATUTORY_ZMW_KEYS = new Set([
	'napsaEmployeeShareZMW',
	'napsaEmployerShareZMW',
	'nhimaEmployeeShareZMW',
	'nhimaEmployerShareZMW',
]);

/** Typed master ZMW when the payroll row stored it; otherwise USD times the rate. */
export function kwachaFromStoredOrRate(
	row: Record<string, unknown> | null | undefined,
	key: string,
	rate: number
): number {
	const stored = Number(row?.[`${key}ZMW`]);
	if (Number.isFinite(stored)) {
		return stored;
	}
	return Number(row?.[key] ?? 0) * rate;
}

/** Penny gap between typed ZMW and the rounded USD amount converted back. */
export function masterZmwDisplayDelta(
	row: Record<string, unknown> | null | undefined,
	rate: number
): number {
	if (!row) {
		return 0;
	}
	let delta = 0;
	for (const key of Object.keys(row)) {
		if (!key.endsWith('ZMW') || STATUTORY_ZMW_KEYS.has(key)) {
			continue;
		}
		const base = key.slice(0, -3);
		if (!base || row[base] === undefined) {
			continue;
		}
		const stored = Number(row[key]);
		const usd = Number(row[base]);
		if (!Number.isFinite(stored) || !Number.isFinite(usd)) {
			continue;
		}
		delta += stored - usd * rate;
	}
	return delta;
}

/** Total row is summed in USD. Copy typed ZMW totals from the employee rows on this page. */
export function withTotalRowZmwSums(rows: any[]): any[] {
	if (!Array.isArray(rows)) {
		return rows;
	}
	const employees = rows.filter((row) => row?.Employee !== 'Total');
	const totalIndex = rows.findIndex((row) => row?.Employee === 'Total');
	if (totalIndex < 0 || employees.length === 0) {
		return rows;
	}
	const keys: string[] = [];
	for (const row of employees) {
		for (const key of Object.keys(row)) {
			if (!key.endsWith('ZMW') || STATUTORY_ZMW_KEYS.has(key)) {
				continue;
			}
			const base = key.slice(0, -3);
			if (base && row[base] !== undefined && keys.indexOf(key) === -1) {
				keys.push(key);
			}
		}
	}
	const total = { ...rows[totalIndex] };
	for (const key of keys) {
		total[key] = employees.reduce(
			(sum, row) => sum + (Number(row[key]) || 0),
			0
		);
	}
	return rows.map((row, index) => (index === totalIndex ? total : row));
}
